import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type CopilotChatSlots = {
  root: Slot<'div'>;
};

/**
 * CopilotChat Props
 */
export type CopilotChatProps = ComponentProps<CopilotChatSlots> & {};

/**
 * State used in rendering CopilotChat
 */
export type CopilotChatState = ComponentState<CopilotChatSlots>;
// TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from CopilotChatProps.
// & Required<Pick<CopilotChatProps, 'propName'>>
